/**
 * @generated SignedSource<<ff18e9e888b770ec75a434f64dc15e37>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RecentActivityRowFragment$data = {
  readonly delegateMetrics: {
    readonly ofLastTenProps: number;
  };
  readonly " $fragmentType": "RecentActivityRowFragment";
};
export type RecentActivityRowFragment$key = {
  readonly " $data"?: RecentActivityRowFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"RecentActivityRowFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RecentActivityRowFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "DelegateMetrics",
      "kind": "LinkedField",
      "name": "delegateMetrics",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ofLastTenProps",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Delegate",
  "abstractKey": null
};

(node as any).hash = "e43a2390ffe8ecc545e0910b408b4462";

export default node;
